// extracted by mini-css-extract-plugin
export default {"chartContainer":"MethaneChart_chartContainer__tCR3i"};